
import { httpMobile } from '@/utils/httpMobile'
import React from 'react'
import { styled } from 'styled-components'
import { useSearchConditionMobile } from '../hooks/useSearchCondition'
import { DownFill,CheckOutline } from 'antd-mobile-icons'
import _ from 'lodash'
import { TreePick,TreeSelectPropsOption, getOptionLabels } from '../TreePick/TreePick'
import { LabelItem } from '../Common/LabelItem'
import { SearchConditionsResponseItemLabel } from '@/component/FilterCommon/hooks/useSearchCondition'

export interface FilterClientAreaMobileProps {
  onChange?: (value: Array<string|number>) => void
  value?: Array<string|number>,
  placeholder?: string
}





export const FilterClientAreaMobile: React.FC<FilterClientAreaMobileProps> = (props) => {
  const { onChange,value, placeholder='客户地区',  ...reset } = props
  const { searchCondition,toggle,visible,loading} = useSearchConditionMobile({ client: ['new_area'] } );
  // const [visible, { toggle }] = useToggle(false);
  let options = searchCondition.client?.new_area || [];
  let optionsFlatten = React.useMemo(()=>{
    return getOptionLabels(searchCondition.client?.new_area || [] , value || [])
  },[searchCondition.client?.new_area,value])
  // let labels = getOptionLabels(options , value || [])
  return <div>
     <LabelItem
      value={value}
      options={optionsFlatten}      
      label={placeholder}
      onClick={()=>{
        toggle()
      }}
    />
      <TreePick
        loading={loading}
        value={value}
        visible={visible}
        options={ options } 
        header={ placeholder }
        { ...reset } 
        onClose={toggle}
        onChange={ (val)=> onChange?.(val) } 
     />
    
  </div>

}
